const CompanyData = {
  logoList: [
    {
      imageUrl2: "ININ_logo.png",
      title: "ININ Games",
      sort: "いにんげーむす",
    },
    {
      imageUrl2: "Columbuscircle_logo.png",
      title: "コロンバスサークル",
      sort: "ころんばすさーくる",
    },
    {
      imageUrl2: "COSEN_logo.png",
      title: "COSEN",
      sort: "こせん",
    },
    {
      imageUrl2: "success_logo.png",
      title: "サクセス",
      sort: "さくせす",
    },
    {
      imageUrl2: "ssj_logo.png",
      title: "シルバースタージャパン",
      sort: "しるばーすたーじゃぱん",
    },
    {
      imageUrl2: "Beep_Logo.png",
      title: "BEEP",
      sort: "びーぷ",
    },
    {
      imageUrl2: "Phoenixx_logo.png",
      title: "Phoenixx",
      sort: "ふぃーにっくす",
    },
    {
      imageUrl2: "mebius_logo.png",
      title: "メビウス",
      sort: "めびうす",
    },
    {
      imageUrl2: "re_logo.png",
      title: "ロケットエンジン",
      sort: "ろけっとえんじん",
    },
    {
      imageUrl2: "APOLLOSOFT_LOGO.png",
      title: "アポロソフト",
      sort: "あぽろそふと",
    },
    {
      imageUrl2: "petidepot_logo.png",
      title: "プチデポット",
      sort: "ぷちでぽっと",
    },
    {
      imageUrl2: "kemco_logo.png",
      title: "ケムコ",
      sort: "けむこ",
    },
    {
      imageUrl2: "playdoujin_logo.png",
      title: "Play,Doujin!Project",
      sort: "ぷれいどーじん",
    },
    {
      imageUrl2: "Qute_logo.png",
      title: "Qute",
      sort: "きゅーと",
    },
    {
      imageUrl2: "busirodo_logo.png",
      title: "ブシロードゲームズ",
      sort: "ぶしろーど",
    },
    {
      imageUrl2: "RS34Logo.png",
      title: "RS34",
      sort: "あーるえす",
    },
    {
      imageUrl2: "gameshop1983_logo.png",
      title: "ゲームショップ1983",
      sort: "げーむしょっぷ",
    },
    {
      imageUrl2: "OperaHouseLogo.png",
      title: "オペラハウス",
      sort: "おぺらはうす",
    },
  ],

  cardList: [
    {
      imageUrl1: "Apollosoft.jpg",
      title: "アポロソフト",
      linkUrl1: "https://www.apollosoft.co.jp/",
      linkUrl2: "https://apollosoft.wixsite.com/pinbollua",
      text:
        "岐阜でゲーム開発をしております。アポロソフトと申します！<br/>今回メビウス様のイベントに参加させて頂くことになりました。<br/>「ピンボルアの勇者」はお子様でも遊んで頂ける、ＲＰＧ風ピンボールゲームです！<br/>ぜひプレイしてみてください！",
      gametitle: "ピンボルアの勇者",
    },
    {
      imageUrl1: "ININ_Cannon Dancer.jpg",
      title: "ININ Games",
      linkUrl1: "https://iningames.jp/",
      linkUrl2:
        "https://iningames.jp/games/%E3%82%AD%E3%83%A3%E3%83%8E%E3%83%B3%E3%83%80%E3%83%B3%E3%82%B5%E3%83%BC/",
      text:
        "1996年に発表された「キャノンダンサー」がついにPS4とSwitchに移植！<br/>爽快なスピード感と流麗なキャラクター動作が高く評価。独特な世界観、見事なシナリオと美しいグラフィック、特にボス戦のサイケな色使いと鮮やかさは必見！",
      gametitle: "キャノンダンサー",
    },
    {
      imageUrl1: "ININ_WonderBoyultimateCollection.jpg",
      title: "ININ Games",
      linkUrl1: "https://iningames.jp/",
      linkUrl2:
        "https://iningames.jp/games/%e3%80%8c%e3%83%af%e3%83%b3%e3%83%80%e3%83%bc%e3%83%9c%e3%83%bc%e3%82%a4-%e3%82%a2%e3%83%ab%e3%83%86%e3%82%a3%e3%83%a1%e3%83%83%e3%83%88-%e3%82%b3%e3%83%ac%e3%82%af%e3%82%b7%e3%83%a7%e3%83%b3%e3%80%8d/",
      text:
        "80年代から90年代にかけてあらゆる世代のゲーマーが熱狂し、世界中で多くのファンを魅了してきた「ワンダーボーイ」！<br/>全6タイトルをオリジナルだけでなく移植版も含めて日本語版を中心に収録！",
      gametitle: "ワンダーボーイアルティメットコレクション",
    },
    {
      imageUrl1: "ININ_Jitsu Squad.jpg",
      title: "ININ Games",
      linkUrl1: "https://iningames.jp/",
      linkUrl2:
        "https://iningames.jp/games/%e3%82%b8%e3%83%84%e3%82%b9%e3%82%af%e3%83%af%e3%83%83%e3%83%89/",
      text:
        "電光石火のスピード感、キャラクターごとのスペシャルアクションや武器を駆使し、邪悪な魔術師をやっつけて銀河を救え！<br/>テンポの良い派手なバトルと超爽快な操作性が特徴のベルトスクロール・アクション！",
      gametitle: "ジツスクワッド",
    },
    {
      imageUrl1: "ININ_Warhammer.jpg",
      title: "ININ Games",
      linkUrl1: "https://iningames.jp/",
      linkUrl2:
        "https://iningames.jp/games/warhammer-40000-shootas-blood-teef/",
      text:
        "ワイルドで大爆発な旅を楽しもう！手描きの2Dアクション・アドベンチャー！ヘア・スクイッグを取り戻すために、ルテウスプライムのハイブシティを練り歩いて人間やオルク、ジーンスティーラーの狂信徒達と派手なバトルで火花を散らせ！",
      gametitle: "Warhammer 40,000:Shootas,Blood & Teef",
    },
    {
      imageUrl1: "COSEN.jpg",
      title: "COSEN",
      linkUrl1: "https://cosen-net.com/",
      linkUrl2: "https://cosen-net.com/kanzentai/",
      text:
        "注意！！このゲームにエッチなコンテンツはありません！このゲームに出てくるのは可愛くてアホなパンツだけ！<br/>パンツ同士の熱いバトル！オンライン対戦に対応したハイスピードパンツアクションゲームです。",
      gametitle: "Panty Party完全体",
    },

    {
      imageUrl1: "Columbuscircle.jpg",
      title: "コロンバスサークル",
      linkUrl1: "https://www.columbuscircle.co.jp/",
      //linkUrl2: "https://cosen-net.com/kanzentai/",
      text:
        "レトロゲーム関連商品の製造・発売でおなじみの、「コロンバスサークル」です！<br>新作ゲームカセットの展示や、アウトレット品の販売を行います。ぜひご来場ください！",
      gametitle: "物販",
    },
    {
      imageUrl1: "success.jpg",
      title: "サクセス",
      linkUrl1: "https://www.success-corp.co.jp/",
      linkUrl2: "https://buccanyar.success-corp.co.jp/",
      text:
        "大海戦タワーオフェンスゲーム！<br/>猫と少女たちの海洋冒険物語。<br/>自分好みに船を改造し蒼き大海にいざ出港！",
      gametitle: "バッカニヤ",
    },
    {
      imageUrl1: "silverstar_onedari.jpg",
      title: "シルバースタージャパン",
      linkUrl1: "https://www.silverstar.co.jp/",
      linkUrl2: "https://onedari.jp/win/",
      text:
        "さとう愛理に将棋を教えちゃおう。<br/>さとう愛理は将棋はまだまだド素人、難しい局面になると「まった」や「ヒント」をおねだりしちゃいます。<br/>おねだりに応えてさとう愛理と仲良くなろう。仲良くなるとステキなご褒美が・・・",
      gametitle: "教えて おねだり将棋",
    },
    {
      imageUrl1: "silverstar_kagawa.jpg",
      title: "シルバースタージャパン",
      linkUrl1: "https://www.silverstar.co.jp/",
      linkUrl2: "https://www.silverstar.co.jp/02products/kagawa/",
      text:
        "女流棋士 香川愛生女流四段が企画・原案・出演の将棋ソフトが登場。<br/>「一緒に指して強くなる」をコンセプトに、香川先生とペアを組み対局できる「ペア対局」など、香川先生と二人三脚の将棋をお楽しみください。",
      gametitle: "香川愛生とふたりで将棋",
    },
    {
      imageUrl1: "beep.jpg",
      title: "BEEP",
      linkUrl1: "https://www.beep-shop.com/ec/",
      linkUrl2: "https://www.beep-shop.com/sap/radirgy2/",
      text:
        "ラジルギ２！<br/>久々のステージ制シューティングでごじゃる。<br/>撃って切ってボムで突っこんで…いや今回はボムを動かせる！１８年ぶりだけど、スタッフほぼ同じ！<br/>※開発中のため『ラジルギ』のプレイアブル出典はありません",
      gametitle: "ラジルギ2",
    },
    {
      imageUrl1: "Phoenixx.jpg",
      title: "Phoenixx",
      linkUrl1: "https://phoenixx.ne.jp/",
      linkUrl2: "https://neverawake.neotro.jp/",
      text:
        "目を覚まさない少女。彼女は夢の中で、モンスターと戦い続けていた…<br/>『NeverAwake』は、手書きによる美しくも禍々しいグラフィックで彩られた独特の世界観と、オリジナリティあふれるゲームルールが特徴の“悪夢系”アクションシューターです。",
      gametitle: "NeverAwake",
    },
    {
      imageUrl1: "mebius.jpg",
      title: "メビウス",
      linkUrl1: "http://d-mebius.com/",
      linkUrl2: "http://d-mebius.com/miasmabreaker/",
      text:
        "闇夜を撃ち祓え！！<br/>ミアズマブレイカーは全方位から襲い来る大量の悪霊（ミアズマ）を 祓っていくツインスティックアクションシューティングです。",
      gametitle: "宵祓い探偵 ミアズマブレイカー",
    },
    {
      imageUrl1: "mebius2.jpg",
      title: "メビウス",
      linkUrl1: "http://d-mebius.com/",
      linkUrl2: "http://d-mebius.com/steelempire/",
      text:
        "スチームパンクな世界観の昔ながらのシューティングゲームです。メガドライブ、ゲームボーイアドバンス、ニンテンドー3DSでリリースされ、コアなファンも多い『鋼鉄帝国』。<br/>避けて撃つ、シューティングゲームの原点を楽しんでください。",
      gametitle: "鋼鉄帝国-Steel Empire-クロニクル",
    },

    {
      imageUrl1: "re_image.jpg",
      title: "ロケットエンジン",
      linkUrl1: "http://studio-siesta.mails.ne.jp/index2.htm",
      linkUrl2: "http://studio-siesta.mails.ne.jp/twf/index.html",
      text:
        "16年間にわたるシリーズのすべてが詰まった集大成的大ボリューム！圧倒的ジャラジャラ感がクセになる唯一無二のプレイフィーリングは、初心者から上級者まですべてのユーザーが必ず楽しめます！",
      gametitle: "トラブル☆ウィッチーズ　ふぁいなる！ ～アマルガムの娘たち～",
    },
    {
      imageUrl1: "petidepot.jpg",
      title: "プチデポット",
      //linkUrl1: "http://studio-siesta.mails.ne.jp/index2.htm",
      linkUrl2: "https://globule.info/gnosia/",
      text:
        "『グノーシア』はＳＦ世界を舞台にしたいわゆる人狼系ゲームを一人でも遊べるようにしたものです。１プレイは１５分程度で、周回するたびに、主人公及び各キャラクターの配役や展開が変化します。",
      gametitle: "グノーシア",
    },
    {
      imageUrl1: "kemco.jpg",
      title: "ケムコ",
      linkUrl1: "https://www.kemco.jp",
      linkUrl2: "https://www.kemco.jp/game/crosstails/ja/",
      text:
        "スマートフォン、家庭用ゲーム機、PC向けにゲームの企画・開発・販売を行っている会社です。<br/>犬族と猫族の戦いを描いた、タクティクス・シミュレーションRPG「クロステイルズ」をご試遊いただけます。是非お越しください！",
      gametitle: "クロステイルズ",
    },
    {
      imageUrl1: "Qute.jpg",
      title: "Qute",
      linkUrl1: "https://game.qute.jp/",
      linkUrl2: "https://eschatos.qute.jp/",
      text:
        "ハイテンポに駆け抜けるスピード感・爽快感！「エスカトス」はXbox 360 で好評を博した正統派・縦スクロールシューティングゲームのNintendo Switch™、PlayStation®4 向け移植タイトルです。",
      gametitle: "エスカトス",
    },
    {
      imageUrl1: "playdoujin.jpg",
      title: "Play,Doujin!Project",
      linkUrl1: "http://playdouj.in/",
      linkUrl2: "http://playdouj.in/raindropsprinters/",
      text:
        "『Play,Doujin!』は、個性あふれる同人・インディゲームを家庭用ゲーム機などに展開するパブリッシング・プログラムです。<br/>今回は新作『Raindrop Sprinters』を展示いたします。シンプルなのに奥深いアクションゲームを是非お試し下さい。",
      gametitle: "Raindrop Sprinters",
    },
    {
      imageUrl1: "busirodo.jpg",
      title: "ブシロードゲームズ",
      linkUrl1: "https://bushiroadgames.com/",
      linkUrl2: "https://twitter.com/MACROSS_SI",
      text: "『マクロス』シリーズの完全新作シューティングゲームです。",
      gametitle: "マクロス -Shooting Insight-",
    },
    {
      imageUrl1: "RS34_IllveloSwamp.jpg",
      title: "RS34",
      linkUrl1: "https://rs34.co.jp/index.html",
      linkUrl2: "https://rs34.co.jp/game/illveloswamp/illveloswamp_index.html",
      text:
        "─沼。<br>・「100」のステージ、「1000を超えるオーダー（ミッション）」 2019年に発売した『イルベロスウォンプ』 　年をまたいでしつこく出典！ 　感染症でなかなかできなかったリアルイベントに今更参加！ 　 　プレイアブル出典だけではなく、 　RS34によるラジルギ２＆イルベロトークイベント開催と 　アウトレットグッズを販売するので、 　是非遊びに来てください。 　 　シューティング初心者、超歓迎。",
      gametitle: "イルベロスウォンプ",
    },
    {
      imageUrl1: "mebius_apa.jpg",
      title: "メビウス",
      linkUrl1: "http://d-mebius.com/",
      linkUrl2: "http://d-mebius.com/narugamigakuen7f/",
      text:
        "飯島多紀哉氏の原作・脚本による家庭用最新作で、選択肢を選ぶアドベンチャーゲームです。<br>2,000を越える選択肢、650を越えるエンディングが準備されており、質・量ともにプレイヤーに支持されている作品です。",
      gametitle: "アパシー鳴神学園七不思議",
    },
    {
      imageUrl1: "mebius_touho.jpg",
      title: "メビウス",
      linkUrl1: "http://d-mebius.com/",
      linkUrl2: "http://d-mebius.com/toho_w_p/",
      text:
        "ハチクマソフト開発の、人気キャラクターたちが繰り広げるやり込み要素満載のRPG二作品のダブルパックです。",
      gametitle: "「東方蒼神縁起V」&「東方幻想魔録W」ダブルパック",
    },
    {
      imageUrl1: "gameshop1983.jpg",
      title: "ゲームショップ1983",
      linkUrl1:
        "https://shop.1983.jp/shop/shop.cgi?class=all&order=&keyword=%93a%93%B0%93%FC&pic_only=1&FF=0&price_sort=5&toppage=yes",
      // linkUrl2: "http://d-mebius.com/toho_w_p/",
      text:
        "札幌の通販専門店です。<br/>先着であすか120%うちわ下敷きの無料配布と、わけありの品などのセールを行います。",
      gametitle: "物販",
    },
    {
      imageUrl1: "OperaHouse2.jpg",
      title: "オペラハウス",
      linkUrl1: "https://www.opera-house.jp/",
      // linkUrl2: "http://d-mebius.com/toho_w_p/",
      text: "ゲーム展示＆対戦会<br/>対戦ゲームで勝った方に粗品をプレゼント",
      gametitle: "マッドストーカー X68000 Z",
    },
    {
      imageUrl1: "OperaHouse.jpg",
      title: "オペラハウス",
      linkUrl1: "https://www.opera-house.jp/",
      // linkUrl2: "http://d-mebius.com/toho_w_p/",
      text:
        "MSXturboR（A1GT）、MSX0Stack 及び<br/>MSXPLAYer（MSX公式エミュレーター最新版＋MSXゲームリーダー）<br/>実際に遊んで、微妙な違いを確かめよう！",
      gametitle: "ラスグレイブ探偵譚　MSX",
    },
  ],
};
export default CompanyData;
